import React, { useContext, useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import {
  Dialog,
  DialogProps,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
  Grid,
  MenuItem,
} from '@material-ui/core'
import { RootContext } from '../../../..'
import { useActionMessages } from '../../../../hooks'
import { UserAction } from '../../../../enums'
import { Form, GeneralTextFieldForm, KeyboardDatePickerForm } from '../../../../custom-components'
import { Loading } from '../../../../shared-components'
import { SaleOrderProfile, updateSaleOrderDueDateAPI } from '../../../../api/smartbestbuys-api'
import { dateFormat } from '../../../../functions'

export interface SOUpdateDueDateFormValues {
  dueDate: Date
  userAction?: number
  actionMessageId?: number
  actionMessage?: string
  remark?: string
}

interface Props extends DialogProps {
  saleOrderProfile: SaleOrderProfile
  onComplete?: () => void
}

const SaleOrderUpdateDueDateDialog: React.FC<Props> = (props) => {
  const { onClose, saleOrderProfile, onComplete } = props
  const { triggerSnackbar } = useContext(RootContext)
  const messages = useActionMessages(UserAction.SODueDateChanged)

  const methods = useForm<SOUpdateDueDateFormValues>({
    defaultValues: {
      userAction: UserAction.SODueDateChanged,
    },
  })

  const {
    control,
    formState: { isSubmitting, errors },
    register,
  } = methods

  useEffect(() => {
    register('dueDate', {
      required: {
        value: true,
        message: 'กรุณาเลือกวันที่ลูกค้ารับของ',
      },
      valueAsDate: true,
    })
  }, [register])

  if (!saleOrderProfile) return <Loading />

  const onSubmit = async (values: SOUpdateDueDateFormValues) => {
    const response = await updateSaleOrderDueDateAPI(saleOrderProfile.id, values)
    if (response?.status === 200) {
      triggerSnackbar('แก้ไขวันที่ลูกค้าต้องการ')
      if (!!onComplete) onComplete()
    } else {
      triggerSnackbar('ไม่สามารถแก้ไขวันที่ลูกค้าต้องการได้')
      if (!!onClose) onClose({}, 'escapeKeyDown')
    }
  }

  return (
    <Dialog fullWidth maxWidth="md" {...props}>
      <FormProvider {...methods}>
        <Form onSubmit={onSubmit}>
          <DialogTitle>แก้ไขวันที่ลูกค้าต้องการ</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                วันนัดหมายปัจจุบัน: {saleOrderProfile.dueDate ? dateFormat(saleOrderProfile.dueDate) : 'ไม่ระบุ'}
              </Grid>

              <Grid item xs={12} md={6}>
                <div className="mt-2">
                  <KeyboardDatePickerForm
                    control={control}
                    label={'วันที่ลูกค้าต้องการใหม่ *'}
                    name="dueDate"
                    value=""
                    rules={{ required: { value: true, message: 'กรุณาเลือกวันที่ลูกค้าต้องการใหม่' } }}
                    fullWidth
                    defaultValue={null}
                    // inputVariant="outlined"
                    size="small"
                    error={!!errors.dueDate}
                    helperText={errors.dueDate?.message}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <GeneralTextFieldForm
                  control={control}
                  name="actionMessageId"
                  select
                  label="สาเหตุ *"
                  rules={{ required: { value: true, message: 'กรุณาเลือกสาเหตุ' } }}
                >
                  {messages.map((message) => (
                    <MenuItem key={message.id} value={message.id}>
                      {message.name}
                    </MenuItem>
                  ))}
                </GeneralTextFieldForm>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={() => onClose && onClose({}, 'backdropClick')}>
              ยกเลิก
            </Button>
            <Button color="primary" variant="contained" type="submit" disabled={isSubmitting}>
              ยืนยัน
            </Button>
          </DialogActions>
        </Form>
      </FormProvider>
    </Dialog>
  )
}

export default SaleOrderUpdateDueDateDialog
